import type { CatalogMode } from "@/app/library/utils";
import { APP_ROUTES } from "@/core/constants";
import type { AppRouteDefinition } from "@/core/router";

import { TemplatePacksPage } from "..";
import { PackDetailPage } from "../detail";

function getTemplatePacksRoute() {
  return APP_ROUTES.superAdmin.library.packs;
}

export function createTemplatePacksRoutes(
  mode: CatalogMode,
): AppRouteDefinition {
  const route = getTemplatePacksRoute();

  return {
    route,
    element: <TemplatePacksPage mode={mode} />,
    children: [
      {
        id: `${route.key}Detail`,
        route,
        element: <PackDetailPage mode={mode} />,
        path: `${route.path}/:packId`,
      },
    ],
  };
}
